import React, { useEffect, Component, useState, useRef } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { useHistory } from 'react-router-dom';
import { Watch } from "react-loader-spinner";
import { ApiService } from '../../containers/Services/apiservice';
import { Helmet } from 'react-helmet';
let apiServices = new ApiService();
const AddMoreBank = () => {
    let history = useHistory();
    const [errorMessage, setErrorMessage] = useState('');
    const [Banks, setBanks] = React.useState([]);
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [userbankdata, setuserbankdata] = useState({ crb_bank_acc_no1: '', confirm_bank_acc_no1: '', crb_bank_acc_type1: 'SB', crb_bank1: '', crb_bank_micr1: '', crb_bank_ifsc1: '', crb_bank_proof1: '', crb_bank_acc_no2: '', confirm_bank_acc_no2: '', crb_bank_acc_type2: '', crb_bank2: '', crb_bank_micr2: '', crb_bank_ifsc2: '', crb_bank_proof2: '', crb_bank_acc_no3: '', confirm_bank_acc_no3: '', crb_bank_acc_type3: '', crb_bank3: '', crb_bank_micr3: '', crb_bank_ifsc3: '', crb_bank_proof3: '' });
    const [canId, setCanId] = useState('')
    const [micrName, setMicrName] = useState('')
    const [showmorebanks, setshowmorebanks] = useState(0);
    useEffect(() => {
        getBanks();
        const dataString = {
        }
        apiServices.getUserData(dataString).then(result => {
            if (result.data.status == 'success') {
                setCanId(result.data.data.gs_can_id)
            }
            else if (result.data.status == "error" && result.data.message == "Session expired") {
                localStorage.removeItem('AUTH_TOKEN');
                // alert(result.data.message)
                setSpinnerLoading(false)
                history.push("/login")
            }
            else {
                alert(result.data.message)
                setSpinnerLoading(false)
            }
        })
    }, []);
    const handleBankData = (e) => {
        const key = e.target.name;
        const value = e.target.value;
        if (key == "crb_bank_ifsc1") {
            if (value.length == 11) {
                apiServices.getMICRGetRequest(value).then(res => {
                    console.log(res)
                    if (res.status == 200) {
                        setMicrName(res.data.MICR)
                        // setMicrName({...micrName, ['crb_bank_micr1']:res.data.MICR})
                    }
                    else {
                        setMicrName('')
                    }
                })
                    .catch(error => {
                        setMicrName('')
                    }
                    )
            } else {
                setMicrName('')
            }
        }
        if (key == "crb_bank_micr1") {
            setMicrName(value)
        }
        else {
            setuserbankdata({ ...userbankdata, [key]: value })
        }
    }
    const getBanks = (e) => {
        apiServices.getBanks().then(result => {
            if (result.data.status == 'success') {
                setBanks(result.data.data);
            }
            else if (result.data.status == "error" && result.data.message == "Session expired") {
                localStorage.removeItem('AUTH_TOKEN');
                // alert(result.data.message)
                setSpinnerLoading(false)
                history.push("/login")
            }
            else {
                alert(result.data.message)
                setSpinnerLoading(false)
            }
        })
    }
    const processstep3 = (e) => {
        var micr = '';
        if (micrName != null) {
            micr = micrName;
        }
        else {
            micr = userbankdata.crb_bank_micr1;
        }
        if (userbankdata.crb_bank_acc_no1 == '' || userbankdata.crb_bank_acc_no1 == undefined) {
            setErrorMessage('Bank Account Number Field Is Required');
            return false;
        }
        else if (userbankdata.confirm_bank_acc_no1 == '' || userbankdata.confirm_bank_acc_no1 == undefined) {
            setErrorMessage('Confirm Bank Account Number Field Is Required');
            return false;
        }
        else if (userbankdata.confirm_bank_acc_no1 != userbankdata.crb_bank_acc_no1) {
            setErrorMessage('Bank Account Number And Confirm Bank Account Number Field Should Be Same');
            return false;
        }
        else if (userbankdata.crb_bank_acc_type1 == '' || userbankdata.crb_bank_acc_type1 == undefined) {
            setErrorMessage('Bank Account Type Field Is Required');
            return false;
        }
        else if (userbankdata.crb_bank1 == '' || userbankdata.crb_bank1 == undefined) {
            setErrorMessage('Please Select Bank Account');
            return false;
        }
        else if ((micr == '' || micr == undefined)) {
            setErrorMessage('Bank MICR Field Is Required');
            return false;
        }
        else if (micr.length > 9) {
            setErrorMessage('Bank MICR Field Should Not Exceeds 9 Characters');
            return false;
        }
        else if (userbankdata.crb_bank_ifsc1 == '' || userbankdata.crb_bank_ifsc1 == undefined) {
            setErrorMessage('Bank IFSC Field Is Required');
            return false;
        }
        else if (userbankdata.crb_bank_ifsc1.length < 11) {
            setErrorMessage('IFSC Code is less than 11 characters');
            return false;
        }
        else if (userbankdata.crb_bank_proof1 == '' || userbankdata.crb_bank_proof1 == undefined) {
            setErrorMessage('Bank Proof Field Is Required');
            return false;
        }
        else {
            setErrorMessage('');
        }
        setSpinnerLoading(true);
        setTimeout(() => {
            const dataString = {
                "crb_bank_acc_no1": userbankdata.crb_bank_acc_no1,
                "crb_bank_acc_type1": userbankdata.crb_bank_acc_type1,
                "crb_bank1": userbankdata.crb_bank1,
                "crb_bank_micr1": micr,
                "crb_bank_ifsc1": userbankdata.crb_bank_ifsc1,
                "crb_bank_proof1": userbankdata.crb_bank_proof1,
                // "crb_bank_acc_no2": userbankdata.crb_bank_acc_no2,
                // "crb_bank_acc_type2": userbankdata.crb_bank_acc_type2,
                // "crb_bank2": userbankdata.crb_bank2,
                // "crb_bank_micr2": userbankdata.crb_bank_micr2,
                // "crb_bank_ifsc2": userbankdata.crb_bank_ifsc2,
                // "crb_bank_proof2": userbankdata.crb_bank_proof3,
                // "crb_bank_acc_no3": userbankdata.crb_bank_acc_no3,
                // "crb_bank_acc_type3": userbankdata.crb_bank_acc_type3,
                // "crb_bank3": userbankdata.crb_bank3,
                // "crb_bank_micr3": userbankdata.crb_bank_micr3,
                // "crb_bank_ifsc3": userbankdata.crb_bank_ifsc3,
                // "crb_bank_proof3": userbankdata.crb_bank_proof3,
            }
            apiServices.saveuserbankdata(dataString).then(result => {
                if (result.data.status == 'success') {
                    // setcr_id(result.data.data);
                    setSpinnerLoading(false);
                    alert('Bank Added Successfully');
                    history.push("/dashboard");
                }
                else if (result.data.status == "error" && result.data.message == "Session expired") {
                    localStorage.removeItem('AUTH_TOKEN');
                    // alert(result.data.message)
                    setSpinnerLoading(false)
                    history.push("/login")
                }
                else {
                    alert(result.data.data);
                    window.location.reload();
                }
            })
        }, 1000);
    }
    return (
        <div>
            <Header />
            <Helmet>
                <title>Bank Details - Goalstox</title>
                {/* <meta name="keywords" content={pageKeywords}/>  */}
                {/* <meta name="description" content={pageDescription} /> */}
            </Helmet>
            <section className='bg-gray-light'>
                <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
                    <div className='overlay-box'>
                        <Watch
                            color="#ffffff"
                            visible={spinnerLoading}
                        />
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row justify-content-md-center">
                        <div className="col-lg-9">
                            <div className="ecan-form">
                                <h6>Bank Account details</h6>
                                <hr></hr>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="ecan-form-group">
                                            <label>Bank A/c No<span style={{ color: '#ff0000' }}>*</span></label>
                                            <input name="crb_bank_acc_no1" value={userbankdata.crb_bank_acc_no1} onChange={handleBankData} type="number"></input>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="ecan-form-group">
                                            <label>Re-Enter Bank A/c No<span style={{ color: '#ff0000' }}>*</span></label>
                                            <input name="confirm_bank_acc_no1" value={userbankdata.confirm_bank_acc_no1} onChange={handleBankData} type="number"></input>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="ecan-form-group">
                                            <label>Account Type<span style={{ color: '#ff0000' }}>*</span></label>
                                            <select name="crb_bank_acc_type1" value={userbankdata.crb_bank_acc_type1} onChange={handleBankData}>
                                                <option value="">Select</option>
                                                <option value="CA">Current Account</option>
                                                <option value="CC">Cash Credit</option>
                                                <option value="FCNR">Foreign Currency Non Resident</option>
                                                <option value="NRE">Non Resident External Account</option>
                                                <option value="NRO">Non Resident Ordinary A/c</option>
                                                <option value="OD">Over Draft Account</option>
                                                <option value="OTH">Others</option>
                                                <option value="PSB">Post Office Savings Account</option>
                                                <option value="SB">Savings Account</option>
                                                <option value="SNRA">Special Non Resident Rupee A/c</option>
                                                <option value="SNRR">Special Non Resident repatriable</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="ecan-form-group">
                                            <label>Bank<span style={{ color: '#ff0000' }}>*</span></label>
                                            <select name="crb_bank1" value={userbankdata.crb_bank1} onChange={handleBankData}>
                                                <option value="">Select Bank</option>
                                                {Banks.map((option, index) => (
                                                    <option key={index} value={option.bank_can_id}>
                                                        {option.bank_name}
                                                    </option>
                                                ))}
                                            </select>
                                            {/* <input name="crb_bank1" value={userbankdata.crb_bank1} onChange={handleBankData} type="text"></input> */}
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="ecan-form-group">
                                            <label>IFSC<span style={{ color: '#ff0000' }}>*</span></label>
                                            <input name="crb_bank_ifsc1" value={userbankdata.crb_bank_ifsc1} onChange={handleBankData} type="text"></input>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="ecan-form-group">
                                            <label>MICR<span style={{ color: '#ff0000' }}>*</span></label>
                                            <input name="crb_bank_micr1" defaultValue={micrName != '' ? micrName : userbankdata.crb_bank_micr1} onChange={handleBankData} type="text"></input>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="ecan-form-group">
                                            <label>Bank Proof<span style={{ color: '#ff0000' }}>*</span></label>
                                            <select name="crb_bank_proof1" value={userbankdata.crb_bank_proof1} onChange={handleBankData}>
                                                <option value="">Select</option>
                                                <option value="14">Latest Bank Passbook</option>
                                                <option value="15">Latest Bank Account Statement</option>
                                                <option value="77">Cancelled Cheque Copy</option>
                                                <option value="78">Bank Letter</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {/* <button type="submit" class="buttonab-line mg-b-20" style={{marginLeft:'0px',paddingLeft:'0px',marginBottom:'20px'}} onClick={(e) => {
                    if(showmorebanks == 1)
                    {setshowmorebanks(0);}
                    else
                    {setshowmorebanks(1);}
                    
                    }}>{showmorebanks == 1?'Remove':'Add another bank account'}<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button> 
                {showmorebanks == 1?
                <>
                <hr></hr>
                <h6>Second Bank Account</h6>
                <hr></hr>
                <div className="row">
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>Bank A/c No</label>
                        <input name = "crb_bank_acc_no2" value={userbankdata.crb_bank_acc_no2} onChange={handleBankData} type="number"></input>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>Re-Enter Bank A/c No</label>
                        <input name="confirm_bank_acc_no2" value={userbankdata.confirm_bank_acc_no2} onChange={handleBankData} type="number"></input>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>Account Type</label>
                        <select name="crb_bank_acc_type2" value={userbankdata.crb_bank_acc_type2} onChange={handleBankData}>
                        <option value="">Select</option>
                        <option value="CA">Current Account</option>
                        <option value="CC">Cash Credit</option>
                        <option value="FCNR">Foreign Currency Non Resident</option>
                        <option value="NRE">Non Resident External Account</option>
                        <option value="NRO">Non Resident Ordinary A/c</option>
                        <option value="OD">Over Draft Account</option>
                        <option value="OTH">Others</option>
                        <option value="PSB">Post Office Savings Account</option>
                        <option value="SB">Savings Account</option>
                        <option value="SNRA">Special Non Resident Rupee A/c</option>
                        <option value="SNRR">Special Non Resident repatriable</option>
                        </select>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>Bank</label>
                        <select name="crb_bank2" value={userbankdata.crb_bank2} onChange={handleBankData}>
                        <option value="">Select Bank</option>    
                        {Banks.map((option, index) => (
                            <option key={index} value={option.bank_can_id}>
                                {option.bank_name}
                            </option>
                            ))}
                         </select>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>MICR</label>
                        <input name="crb_bank_micr2" value={userbankdata.crb_bank_micr2} onChange={handleBankData} type="text"></input>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>IFSC</label>
                        <input name="crb_bank_ifsc2" value={userbankdata.crb_bank_ifsc2} onChange={handleBankData} type="text"></input>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>Bank Proof</label>
                        <select name="crb_bank_proof2" value={userbankdata.crb_bank_proof2} onChange={handleBankData}>
                        <option value="">Select</option>
                        <option value="14">Latest Bank Passbook</option>
                        <option value="15">Latest Bank Account Statement</option>
                        <option value="77">Cheque Copy</option>
                        <option value="78">Bank Letter</option>
                        </select>
                    </div>
                    </div>
                </div>
                <hr></hr>
                <h6>Third Bank Account</h6>
                <hr></hr>
                <div className="row">
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>Bank A/c No</label>
                        <input name = "crb_bank_acc_no3" value={userbankdata.crb_bank_acc_no3} onChange={handleBankData} type="number"></input>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>Re-Enter Bank A/c No</label>
                        <input name="confirm_bank_acc_no3" value={userbankdata.confirm_bank_acc_no3} onChange={handleBankData} type="number"></input>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>Account Type</label>
                        <select name="crb_bank_acc_type3" value={userbankdata.crb_bank_acc_type3} onChange={handleBankData}>
                        <option value="">Select</option>
                        <option value="CA">Current Account</option>
                        <option value="CC">Cash Credit</option>
                        <option value="FCNR">Foreign Currency Non Resident</option>
                        <option value="NRE">Non Resident External Account</option>
                        <option value="NRO">Non Resident Ordinary A/c</option>
                        <option value="OD">Over Draft Account</option>
                        <option value="OTH">Others</option>
                        <option value="PSB">Post Office Savings Account</option>
                        <option value="SB">Savings Account</option>
                        <option value="SNRA">Special Non Resident Rupee A/c</option>
                        <option value="SNRR">Special Non Resident repatriable</option>
                        </select>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>Bank</label>
                        <select name="crb_bank3" value={userbankdata.crb_bank3} onChange={handleBankData}>
                        <option value="">Select Bank</option>    
                        {Banks.map((option, index) => (
                            <option key={index} value={option.bank_can_id}>
                                {option.bank_name}
                            </option>
                            ))}
                         </select>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>MICR</label>
                        <input name="crb_bank_micr3" value={userbankdata.crb_bank_micr3} onChange={handleBankData} type="text"></input>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>IFSC</label>
                        <input name="crb_bank_ifsc3" value={userbankdata.crb_bank_ifsc3} onChange={handleBankData} type="text"></input>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>Bank Proof</label>
                        <select name="crb_bank_proof3" value={userbankdata.crb_bank_proof3} onChange={handleBankData}>
                        <option value="">Select</option>
                        <option value="14">Latest Bank Passbook</option>
                        <option value="15">Latest Bank Account Statement</option>
                        <option value="77">Cheque Copy</option>
                        <option value="78">Bank Letter</option>
                        </select>
                    </div>
                    </div>
                    </div>
                    </>:''
                    } */}
                                {
                                    errorMessage != '' ?
                                        <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                                }
                                <div className="theme-button mg-t-10">
                                    <a className="btn" onClick={processstep3}>
                                        Save & Continue
                                    </a>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>;
            </section>
            <Footer />
        </div>
    );
}

export default AddMoreBank;